import { createSlice } from '@reduxjs/toolkit'

export interface CommonState {
    IsLoading: boolean
}

const initialState: CommonState = {
    IsLoading: false,
}

export const CommonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        startLoader: (state) => {
            state.IsLoading = true
        },
        stopLoader: (state) => {
            state.IsLoading = false
        },
    },
})

export const { startLoader, stopLoader } = CommonSlice.actions

export default CommonSlice.reducer
